import styled from "@emotion/styled";

const ProjectInsightsSectionBase = styled.div`
  margin: auto;
  max-width: 100%;

  > div {
    margin: auto;
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    max-width: 732px;
  }

  @media ${(props) => props.theme.bp.desktopUp} {
    max-width: 1116px;
  }
`;

export const ProjectInsightsLocationsSection = styled(
  ProjectInsightsSectionBase
)`
  width: 100%;
`;
